var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConversationTopics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.126 86.027",
    width: 93,
    height: 86,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#205763",
    d: "M0 0h93.126v86.027H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#205763",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6 86.027a3.919 3.919 0 0 1-1.379-.253A3.85 3.85 0 0 1 9.7 82.141v-8.42H3.88A3.885 3.885 0 0 1 0 69.844V38.802a3.885 3.885 0 0 1 3.88-3.881h52.384a3.885 3.885 0 0 1 3.88 3.88v31.042a3.885 3.885 0 0 1-3.88 3.88H26.1l-9.6 10.972a3.849 3.849 0 0 1-2.906 1.33M3.88 38.802v31.042h7.76a1.94 1.94 0 0 1 1.94 1.94v10.355l10.181-11.633a1.941 1.941 0 0 1 1.46-.662h31.045V38.802Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.47 68.566a3.849 3.849 0 0 1-2.906-1.33l-9.6-10.973h-6.881v-3.88h7.761a1.941 1.941 0 0 1 1.46.663l10.179 11.633V54.323a1.94 1.94 0 0 1 1.94-1.94h5.82V25.221h-48.5v7.761h-3.881v-7.761a3.885 3.885 0 0 1 3.88-3.88h48.5a3.885 3.885 0 0 1 3.88 3.88v27.162a3.885 3.885 0 0 1-3.88 3.88h-3.88v8.417a3.85 3.85 0 0 1-2.516 3.633 3.92 3.92 0 0 1-1.379.253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.521 32.982h-3.88v-19.4a3.885 3.885 0 0 1 3.88-3.882h44.62a3.885 3.885 0 0 1 3.88 3.88v5.82h-3.88v-5.82h-44.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.545 19.399h-3.88V3.88h-38.8v3.88h-3.883V3.88a3.885 3.885 0 0 1 3.88-3.881h38.8a3.885 3.885 0 0 1 3.88 3.88Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConversationTopics);
export default __webpack_public_path__ + "static/media/icon-conversation-topics.2b5178471a5c368d00694bcd4ca9fadb.svg";
export { ForwardRef as ReactComponent };